import { mapTaskType, useFindAllTaskListItems } from '@api';
import { faList } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, Indicator } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { countUnreadTasks } from './helpers';

type TasksTopBarTogglePropsType = {
  onClick: () => void;
};

export const TasksTopBarToggle: React.FC<TasksTopBarTogglePropsType> = ({
  onClick,
}) => {
  const { t } = useTranslation('tasks');

  const { data: unreadCount = 0, isError } = useFindAllTaskListItems({
    query: {
      select: (response) => countUnreadTasks(response.data.map(mapTaskType)),
    },
  });

  const isDisabled = isError || unreadCount === 0;

  return (
    <Indicator
      inline
      label={unreadCount}
      size={16}
      color="blue"
      disabled={isDisabled}
    >
      <ActionIcon
        variant="subtle"
        onClick={onClick}
        c="var(--mantine-color-text-5)"
        aria-label={t('TITLE')}
      >
        <FontAwesomeIcon icon={faList} />
      </ActionIcon>
    </Indicator>
  );
};
